export default "__VITE_ASSET__C9bf$Kw2__"